module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main_container "
  }, [_c('div', {
    staticClass: "jbxxDiv"
  }, [_c('p', {
    staticClass: "jbxx"
  }, [_vm._v("基本信息")]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "position": "relative"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "活动标题：",
      "required": ""
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "placeholder": "请输入活动名称(20字符以内)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.datas.Name),
      callback: function($$v) {
        _vm.$set(_vm.datas, "Name", $$v)
      },
      expression: "datas.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "optionscity",
    staticStyle: {
      "display": "flex",
      "width": "30%",
      "margin-left": "10px"
    },
    attrs: {
      "label": "所属城市：",
      "required": ""
    }
  }, [(_vm.type == 0 ? true : false) ? _c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": _vm.disablecs,
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.hdcs),
      callback: function($$v) {
        _vm.hdcs = $$v
      },
      expression: "hdcs"
    }
  }) : _c('el-input', {
    staticStyle: {
      "margin": "0 10 0 10px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.cityname),
      callback: function($$v) {
        _vm.cityname = $$v
      },
      expression: "cityname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "50%"
    },
    attrs: {
      "label": "活动时间：",
      "required": ""
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%",
      "cursor": "pointer"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "editable": _vm.iseditable,
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "请选择活动开始日期",
      "end-placeholder": "请选择活动结束日期"
    },
    on: {
      "change": _vm.changetime
    },
    model: {
      value: (_vm.hdsj),
      callback: function($$v) {
        _vm.hdsj = $$v
      },
      expression: "hdsj"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('div', {
    staticClass: "inputDiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datas.IsBanner),
      expression: "datas.IsBanner"
    }],
    attrs: {
      "disabled": _vm.type == 2,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datas.IsBanner) ? _vm._i(_vm.datas.IsBanner, null) > -1 : (_vm.datas.IsBanner)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.datas.IsBanner,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.datas, "IsBanner", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.datas, "IsBanner", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.datas, "IsBanner", $$c)
        }
      }
    }
  }), _c('label', [_vm._v("活动banner")])]), _vm._v(" "), (_vm.datas.IsBanner) ? _c('div', {
    staticClass: "showDiv mainbanner"
  }, [_c('div', {
    staticStyle: {
      "margin-top": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("活动banner : ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-left": "20px"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#888"
    }
  }, [_vm._v("PC端")]), _vm._v(" "), _c('p', [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "disabled": _vm.type == 2,
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUpload
    }
  }, [(_vm.datas.Pc_Banner) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "650px",
      "height": "270px"
    },
    attrs: {
      "src": _vm.ResultUrlPc
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：1920*450，支持的图片格式：jpg、png。")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "5%"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#888"
    }
  }, [_vm._v("小程序")]), _vm._v(" "), _c('p', [_c('el-upload', {
    staticClass: "avatar-uploader1",
    attrs: {
      "disabled": _vm.type == 2,
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeAvatarUploadtwo
    }
  }, [(_vm.datas.Wechat_Banner) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "270px",
      "height": "270px"
    },
    attrs: {
      "src": _vm.ResultUrlXcx
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon1"
  })])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：750*750，支持的图片格式：jpg、png。")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inputDiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datas.IsSignUp),
      expression: "datas.IsSignUp"
    }],
    attrs: {
      "disabled": _vm.type == 2,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datas.IsSignUp) ? _vm._i(_vm.datas.IsSignUp, null) > -1 : (_vm.datas.IsSignUp)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.datas.IsSignUp,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.datas, "IsSignUp", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.datas, "IsSignUp", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.datas, "IsSignUp", $$c)
        }
      }
    }
  }), _c('label', [_vm._v("报名区域")])]), _vm._v(" "), (_vm.datas.IsSignUp) ? _c('div', {
    staticClass: "showDiv"
  }, [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "区域标题 : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "placeholder": "请输入报名区域标题(10字符以内)",
      "maxlength": "10"
    },
    model: {
      value: (_vm.datas.SignUpTitle),
      callback: function($$v) {
        _vm.$set(_vm.datas, "SignUpTitle", $$v)
      },
      expression: "datas.SignUpTitle"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inputDiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datas.IsScheme),
      expression: "datas.IsScheme"
    }],
    attrs: {
      "disabled": _vm.type == 2,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datas.IsScheme) ? _vm._i(_vm.datas.IsScheme, null) > -1 : (_vm.datas.IsScheme)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.datas.IsScheme,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.datas, "IsScheme", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.datas, "IsScheme", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.datas, "IsScheme", $$c)
        }
      }
    }
  }), _c('label', [_vm._v("活动方案")])]), _vm._v(" "), (_vm.datas.IsScheme) ? _c('div', {
    staticClass: "showDiv"
  }, [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "方案标题 : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "placeholder": "请输入活动方案标题(10字符以内)",
      "maxlength": "10"
    },
    model: {
      value: (_vm.datas.SchemeTitle),
      callback: function($$v) {
        _vm.$set(_vm.datas, "SchemeTitle", $$v)
      },
      expression: "datas.SchemeTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("活动政策：")]), _vm._v(" "), _c('div', [_c('el-upload', {
    staticClass: "avatar-uploaderfuHdzc",
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "action": "serverUrl",
      "name": "img",
      "show-file-list": false,
      "before-upload": _vm.beforeUploadPolicy
    }
  }), _vm._v(" "), _c('el-row', [_c('quill-editor', {
    ref: "hdzcQuillEditor",
    attrs: {
      "disabled": _vm.type == 2,
      "options": _vm.editorOptionHdzc
    },
    model: {
      value: (_vm.datas.Policy),
      callback: function($$v) {
        _vm.$set(_vm.datas, "Policy", $$v)
      },
      expression: "datas.Policy"
    }
  })], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inputDiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datas.IsGoods),
      expression: "datas.IsGoods"
    }],
    attrs: {
      "disabled": _vm.type == 2,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datas.IsGoods) ? _vm._i(_vm.datas.IsGoods, null) > -1 : (_vm.datas.IsGoods)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.datas.IsGoods,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.datas, "IsGoods", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.datas, "IsGoods", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.datas, "IsGoods", $$c)
        }
      }
    }
  }), _c('label', [_vm._v("活动商品")])]), _vm._v(" "), (_vm.datas.IsGoods) ? _c('div', {
    staticClass: "showDiv"
  }, [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "秒杀标题 : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "placeholder": "限时秒杀的商品(10字符以内)",
      "maxlength": "10"
    },
    model: {
      value: (_vm.datas.GoodsTitle1),
      callback: function($$v) {
        _vm.$set(_vm.datas, "GoodsTitle1", $$v)
      },
      expression: "datas.GoodsTitle1"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "商品标题 : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "placeholder": "参与活动的商品(10字符以内)",
      "maxlength": "10"
    },
    model: {
      value: (_vm.datas.GoodsTtitle2),
      callback: function($$v) {
        _vm.$set(_vm.datas, "GoodsTtitle2", $$v)
      },
      expression: "datas.GoodsTtitle2"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("商品列表 : ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-table', {
    staticClass: "ban_tab",
    staticStyle: {
      "height": "auto",
      "margin-left": "-14px",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.datas.Goods,
      "stripe": "",
      "border": "",
      "header-cell-style": {
        background: '#bbbbbb'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "商品名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Name
          }
        }, [_vm._v(_vm._s(scope.row.Name))])]
      }
    }], null, false, 4262105275)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "BrandName",
      "label": "所属品牌",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.BrandName
          }
        }, [_vm._v(_vm._s(scope.row.BrandName))])]
      }
    }], null, false, 1855282939)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IsSkName",
      "label": "是否秒杀",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.IsSkName
          }
        }, [_vm._v(_vm._s(scope.row.IsSkName))])]
      }
    }], null, false, 2502014651)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderNumber",
      "label": "顺序",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.OrderNumber
          }
        }, [_vm._v(_vm._s(scope.row.OrderNumber))])]
      }
    }], null, false, 3554423899)
  }), _vm._v(" "), (_vm.SeeDetails) ? _c('el-table-column', {
    attrs: {
      "prop": "",
      "label": "操作",
      "width": "270px",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.deleteone(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v("删除\n                      ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.spUpordown(0, scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v("向上\n                      ")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.spUpordown(1, scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v("向下\n                      ")])]
      }
    }], null, false, 3027780196)
  }, [_c('template', {
    slot: "header"
  }, [_c('button', {
    staticClass: "addCanzhan",
    on: {
      "click": function($event) {
        return _vm.addSp()
      }
    }
  }, [_vm._v("新增参展商品")])])], 2) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar_footer",
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-right": "14px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndex,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.hdspCurrentChange
    }
  })], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inputDiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datas.IsBrand),
      expression: "datas.IsBrand"
    }],
    attrs: {
      "disabled": _vm.type == 2,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datas.IsBrand) ? _vm._i(_vm.datas.IsBrand, null) > -1 : (_vm.datas.IsBrand)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.datas.IsBrand,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.datas, "IsBrand", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.datas, "IsBrand", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.datas, "IsBrand", $$c)
        }
      }
    }
  }), _c('label', [_vm._v("活动品牌")])]), _vm._v(" "), (_vm.datas.IsBrand) ? _c('div', {
    staticClass: "showDiv"
  }, [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "position": "relative"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "品牌标题 : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "placeholder": "请输入活动品牌标题(10字符以内)",
      "maxlength": "10"
    },
    model: {
      value: (_vm.datas.BrandTittle),
      callback: function($$v) {
        _vm.$set(_vm.datas, "BrandTittle", $$v)
      },
      expression: "datas.BrandTittle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "12px",
      "white-space": "nowrap"
    }
  }, [_vm._v("品牌列表 : ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('el-table', {
    staticClass: "ban_tab",
    staticStyle: {
      "height": "auto",
      "margin-left": "-14px",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.datas.Brands,
      "stripe": "",
      "border": "",
      "header-cell-style": {
        background: '#bbbbbb'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "品牌名称",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.Name
          }
        }, [_vm._v(_vm._s(scope.row.Name))])]
      }
    }], null, false, 4262105275)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "OrderNumber",
      "label": "顺序",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "overflow": "hidden",
            "text-overflow": "ellipsis",
            "white-space": "nowrap"
          },
          attrs: {
            "title": scope.row.OrderNumber
          }
        }, [_vm._v(_vm._s(scope.row.OrderNumber))])]
      }
    }], null, false, 3554423899)
  }), _vm._v(" "), (_vm.SeeDetails) ? _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "270px",
      "fixed": "right",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.deleteTwo(scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v("删除")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.ppUpordown(0, scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-upload2"
        }), _vm._v("向上")]), _vm._v(" "), _c('span', {
          staticStyle: {
            "color": "#6786b4",
            "margin-left": "8px",
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.ppUpordown(1, scope)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-download"
        }), _vm._v("向下")])]
      }
    }], null, false, 108301630)
  }, [_c('template', {
    slot: "header"
  }, [_c('button', {
    staticClass: "addCanzhan",
    on: {
      "click": function($event) {
        return _vm.addPp()
      }
    }
  }, [_vm._v("新增参展品牌")])])], 2) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar_footer",
    staticStyle: {
      "padding-top": "10px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right",
      "margin-right": "14px"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "current-page": _vm.pageIndexTwo,
      "total": _vm.totalTwo
    },
    on: {
      "current-change": _vm.hdppCurrentChange
    }
  })], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inputDiv"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.datas.IsAddress),
      expression: "datas.IsAddress"
    }],
    attrs: {
      "disabled": _vm.type == 2,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.datas.IsAddress) ? _vm._i(_vm.datas.IsAddress, null) > -1 : (_vm.datas.IsAddress)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.datas.IsAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.datas, "IsAddress", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.datas, "IsAddress", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.datas, "IsAddress", $$c)
        }
      }
    }
  }), _c('label', [_vm._v("活动地址")])]), _vm._v(" "), (_vm.datas.IsAddress) ? _c('div', {
    staticClass: "showDiv"
  }, [_c('el-form', {
    staticClass: "demo-form-inline findform",
    staticStyle: {
      "margin-top": "10px",
      "display": "flex",
      "position": "relative"
    },
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "地址标题 : "
    }
  }, [_c('el-input', {
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "placeholder": "请输入活动地址标题(10字符以内)",
      "maxlength": "10"
    },
    model: {
      value: (_vm.datas.AddressTitle),
      callback: function($$v) {
        _vm.$set(_vm.datas, "AddressTitle", $$v)
      },
      expression: "datas.AddressTitle"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v("活动地址：")]), _vm._v(" "), _c('div', [_c('el-upload', {
    staticClass: "avatar-uploaderfuHddz",
    staticStyle: {
      "margin-top": "-20px"
    },
    attrs: {
      "disabled": _vm.type == 2,
      "action": "serverUrl",
      "name": "img",
      "show-file-list": false,
      "before-upload": _vm.beforeUploadAddress
    }
  }), _vm._v(" "), _c('el-row', [_c('quill-editor', {
    ref: "hddzQuillEditor",
    attrs: {
      "disabled": _vm.type == 2,
      "options": _vm.editorOptionHddz
    },
    model: {
      value: (_vm.datas.Address),
      callback: function($$v) {
        _vm.$set(_vm.datas, "Address", $$v)
      },
      expression: "datas.Address"
    }
  })], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "suBmit"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    }
  }, [_vm._v("返 回")]), _vm._v(" "), (_vm.SeeDetails) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.eitm()
      }
    }
  }, [_vm._v("保 存")]) : _vm._e()], 1)])], 1), _vm._v(" "), (_vm.commodityVisible) ? _c('addExhibitorsCategory', {
    ref: "addCommodity",
    attrs: {
      "guid": _vm.guid,
      "cityId": _vm.datas.CityId
    },
    on: {
      "refreshDataList": _vm.refreshSelectGoods
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brandVisible) ? _c('addExhibitorsBrand', {
    ref: "addBrand",
    attrs: {
      "guid": _vm.guid,
      "cityId": _vm.datas.CityId
    },
    on: {
      "refreshDataList": _vm.refreshSelectBrand
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be729148!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/staging/ActivityDetails.vue
// module id = 1747
// module chunks = 3